import { darken } from 'polished';
import styled, { css } from 'styled-components';
import { Colors, toRem } from '.';


export const TextButton = styled.div<{ size?: string | number, color?: string, underline?: boolean }>`
    display: inline-flex;
    align-items: center;
    color: ${p => p.color ?? Colors.primary};
    ${p => p.size && css`font-size: ${toRem(p.size)};`}

    &:active {
        color: ${p => darken(0.2, p.color ?? Colors.primary)};
    }

    &:hover {
        cursor: pointer;
        user-select: none;
        color: ${p => darken(p.underline ? 0 : 0.2, p.color ?? Colors.primary)};
        text-decoration: ${p => p.underline ? 'underline' : 'none'};
    }

    svg {
        margin-right: .5em;
    }
`;
